export enum AuthorityTef {
  REGISTER_PAYMENTS_TEF = '20.1.2',
  CANCEL_PAYMENTS_TEF = '20.1.3',
}
